import React from 'react'

export const WorklistView = () => {
  return (
    <div className="content">
    <div>Page about Worklist</div>
    </div>
  )
}
